export default __webpack_public_path__ + "media/Dry-Food-Flour.153ff7b2.png";